import { combineReducers } from 'redux'

import { transactionsGraphProfile } from './transactionsGraph'
import { transactionsProfile } from './transactions'
import { transactionsDownloadProfile } from './transactionsDownload'
import { exchangeTransactionsGraphProfile } from './exchangeTransactionsGraph'

export const transactionsReducer = combineReducers({
  transactionsProfile,
  transactionsGraphProfile,
  transactionsDownloadProfile,
  exchangeTransactionsGraphProfile
})
